// WhatsApp utility for form submissions
export const WHATSAPP_NUMBER = '918679333354';

export const sendToWhatsApp = (formData, formType = 'General Inquiry') => {
  const now = new Date();
  const dateTime = now.toLocaleString('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Asia/Kolkata'
  });

  // Build the WhatsApp message
  let message = `🌟 *New ${formType}*\n`;
  message += `━━━━━━━━━━━━━━━━━━\n\n`;
  
  if (formData.name) {
    message += `👤 *Name:* ${formData.name}\n`;
  }
  
  if (formData.phone) {
    message += `📱 *Phone:* ${formData.phone}\n`;
  }
  
  if (formData.email) {
    message += `📧 *Email:* ${formData.email}\n`;
  }
  
  if (formData.eventType) {
    message += `💍 *Event Type:* ${formData.eventType}\n`;
  }
  
  if (formData.eventDate) {
    message += `📅 *Event Date:* ${formData.eventDate}\n`;
  }
  
  if (formData.guestCount) {
    message += `👥 *Guest Count:* ${formData.guestCount}\n`;
  }

  if (formData.companyName) {
    message += `🏢 *Company:* ${formData.companyName}\n`;
  }

  if (formData.budget) {
    message += `💰 *Budget:* ${formData.budget}\n`;
  }
  
  if (formData.message) {
    message += `\n💬 *Message/Requirements:*\n${formData.message}\n`;
  }
  
  message += `\n━━━━━━━━━━━━━━━━━━\n`;
  message += `🕐 *Submitted:* ${dateTime}\n`;
  message += `📍 *Source:* Website Form`;

  // Create WhatsApp URL
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  
  // Open WhatsApp in new tab; mobile browsers (iPhone Safari) block that after a form submit, so fall back to the same tab
  const win = window.open(whatsappUrl, '_blank');
  if (!win) setTimeout(() => { window.location.href = whatsappUrl; }, 1200);
  
  return true;
};
